/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Checklist } from '../models/Checklist';
import type { ItemDefinition } from '../models/ItemDefinition';
import type { ItemDefinitionListDto } from '../models/ItemDefinitionListDto';
import type { WorkflowDefinition } from '../models/WorkflowDefinition';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ItemDefinitionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all compliance items from the DB.
     * @param orgGuid
     * @returns ItemDefinitionListDto OK
     * @throws ApiError
     */
    public getAllItemDefinitionDtos(
        orgGuid: string,
    ): CancelablePromise<Array<ItemDefinitionListDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ItemDefinition/{orgGuid}/GetAllItemDefinitionDtos',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a single compliance item by its guid.
     * @param itemDefinitionGuid
     * @param orgGuid
     * @returns ItemDefinition OK
     * @throws ApiError
     */
    public getItemDefinition(
        itemDefinitionGuid: string,
        orgGuid: string,
    ): CancelablePromise<ItemDefinition> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ItemDefinition/{orgGuid}/{itemDefinitionGuid}/GetItemDefinition',
            path: {
                'itemDefinitionGuid': itemDefinitionGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a single compliance item by its form guid.
     * @param formDefinitionGuid
     * @param orgGuid
     * @returns ItemDefinition OK
     * @throws ApiError
     */
    public getComplianceItemDefinitionFromFormGuid(
        formDefinitionGuid: string,
        orgGuid: string,
    ): CancelablePromise<ItemDefinition> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ItemDefinition/{orgGuid}/{formDefinitionGuid}/GetComplianceItemDefinitionFromFormGuid',
            path: {
                'formDefinitionGuid': formDefinitionGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all checklists associated with a compliance item.
     * @param itemDefinitionGuid The item's guid.
     * @param orgGuid
     * @returns Checklist OK
     * @throws ApiError
     */
    public getAssociatedChecklists(
        itemDefinitionGuid: string,
        orgGuid: string,
    ): CancelablePromise<Array<Checklist>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ItemDefinition/{orgGuid}/{itemDefinitionGuid}/GetAssociatedChecklists',
            path: {
                'itemDefinitionGuid': itemDefinitionGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all checklists associated with a compliance item.
     * @param itemDefinitionGuid The item's guid.
     * @param orgGuid
     * @returns WorkflowDefinition OK
     * @throws ApiError
     */
    public getAssociatedWorkflows(
        itemDefinitionGuid: string,
        orgGuid: string,
    ): CancelablePromise<Array<WorkflowDefinition>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ItemDefinition/{orgGuid}/{itemDefinitionGuid}/GetAssociatedWorkflows',
            path: {
                'itemDefinitionGuid': itemDefinitionGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new compliance item. Can be used to create a new item or copy an existing one.
     * @param requestBody
     * @returns ItemDefinition OK
     * @throws ApiError
     */
    public createItemDefinition(
        requestBody?: ItemDefinition,
    ): CancelablePromise<ItemDefinition> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/ItemDefinition/CreateItemDefinition',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update an existing compliance item.
     * @param guid
     * @param requestBody The updated item's details.
     * @returns ItemDefinition OK
     * @throws ApiError
     */
    public updateItemDefinition(
        guid: string,
        requestBody?: ItemDefinition,
    ): CancelablePromise<ItemDefinition> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/ItemDefinition/{guid}/UpdateItemDefinition',
            path: {
                'guid': guid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete an existing compliance item.
     * @param itemDefinitionGuid The item's guid.
     * @param orgGuid
     * @returns ItemDefinition OK
     * @throws ApiError
     */
    public deleteItemDefinition(
        itemDefinitionGuid: string,
        orgGuid: string,
    ): CancelablePromise<ItemDefinition> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/ItemDefinition/{orgGuid}/{itemDefinitionGuid}/DeleteItemDefinition',
            path: {
                'itemDefinitionGuid': itemDefinitionGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
